import StripChat from "./StripChat";
import { useEffect, useState } from "react";
import { IModel } from "../../../services/StripChatService";
import { useModelsQuery } from "./queries";

interface IProps {
  position: number;
}

const AD_POSITION_FACTOR = 5;

export const StripChatAdDispatcher = ({ position }: IProps) => {
  const [models, setModels] = useState<IModel[]>([]);

  const canShow = position === 2 || (position - 2) % AD_POSITION_FACTOR === 0;
  const index = (position - 2) % AD_POSITION_FACTOR === 0 ? (position - 2) / AD_POSITION_FACTOR : 0;

  const { isSuccess, data } = useModelsQuery({
    forceClient: "1",
    strict: "1",
    fields: "geobans",
    limit: "20",
    tag: "girls/american"
  });

  useEffect(() => {
    isSuccess && data?.models && setModels(data.models);
  }, [isSuccess, data]);

  if (!canShow) {
    return null;
  }

  return (<StripChat key="StripChat" model={models[index]}/>);
};
